export default __webpack_public_path__ + "e95ca28c5c3a11ef8ebbcbd9f4b64aca.png";